import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Index from "./pages/Index";
import SuccessStory from "./pages/SuccessStory";
import SearchResults from "./pages/SearchResults";
import Contact from "./pages/Contact";
import Achievers from "./pages/Achievers";
import NotFound from "./pages/NotFound";
import React from 'react';
import ScrollToTop from "./components/utils/ScrollToTop";
import PageTracker from "./components/utils/PageTracker";

// Use HashRouter for better compatibility across all hosting environments
const Router = HashRouter;

const App = () => {
  // Create a new QueryClient instance inside the component
  const queryClient = new QueryClient();
  
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Router>
            <ScrollToTop />
            <PageTracker />
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/success-story" element={<SuccessStory />} />
              <Route path="/success-story/:storyId" element={<SuccessStory />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/achievers" element={<Achievers />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;
